import React, { useEffect, useRef, useState } from 'react';
import "../CSS/Popups.css";
import MeasureTool from "measuretool-googlemaps-v3";




const loadGoogleMapsScript = (callback) => {
  const existingScript = document.getElementById('googleMapsScript');

  


  if (!existingScript) {
    const script = document.createElement('script');
    const Google_API_key = process.env.REACT_APP_API_URL_GOOGLE_MAPS_API_KEY;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${Google_API_key}&libraries=geometry,places,marker&v=weekly`;
    script.id = 'googleMapsScript';
    script.setAttribute('loading', 'async'); 
    script.async = true; 
    script.defer = true; 
    document.body.appendChild(script);

    script.onload = () => {
      if (callback) callback();
    };
  }

  if (existingScript && callback) callback();
};

function findGeographicCentroid(locations) {
  let totalLat = 0;
  let totalLng = 0;
  let count = 0;

  locations.forEach(location => {
    if (location.position && location.position.Latitude && location.position.Longitude) {
      totalLat += location.position.Latitude;
      totalLng += location.position.Longitude;
      count++;
    }
  });

  if (count === 0) {
    return null; // Return null if no valid positions found
  }

  const centroid = [
    totalLat / count,
    totalLng / count
  ];

  return centroid;
}

const GoogleMapProperties = ({ locations }) => {
  const mapRef = useRef(null); // Ref for the map DOM element
  const mapInstance = useRef(null); // Ref for the Google Maps instance
  const markersRef = useRef([]); // Ref for the current markers
  const measureToolRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);

  // Load the Google Maps script on component mount
  useEffect(() => {
    loadGoogleMapsScript(() => setMapLoaded(true));
  }, []);

  // Initialize the map once the script is loaded
  useEffect(() => {
    if (mapLoaded && mapInstance.current && !measureToolRef.current) {
      // Initialize MeasureTool
      measureToolRef.current = new MeasureTool(mapInstance.current, {
        showSegmentLength: true,
        unit: "metric", // Use metric units (kilometers/meters)
      });
  
      // Add right-click listener to the map
      mapInstance.current.addListener("contextmenu", (event) => {
        // Toggle the MeasureTool
        if (measureToolRef.current.isActive()) {
          measureToolRef.current.stop(); // Deactivate the tool if it's already active
        } else {
          measureToolRef.current.start(); // Activate the tool
        }
      });
    }
  }, [mapLoaded]);

  // Dynamically update markers when locations change
  useEffect(() => {
    const initMapAndMarkers = async () => {
      if (mapLoaded) {
        if (!mapInstance.current) {
          const { Map } = await window.google.maps.importLibrary("maps");
          const center = { lat: 57.14589702347154, lng: -2.253011357843587 };
  
          mapInstance.current = new Map(mapRef.current, {
            zoom: 9,
            center,
            mapId: "4504f8b37365c3d0",
            scaleControl:true
          });

          measureToolRef.current = new MeasureTool(mapInstance.current, {
            showSegmentLength: true,
            unit: "metric",
          });
        }

        // Clear existing markers
        markersRef.current.forEach((marker) => marker.setMap(null));
        markersRef.current = [];
  
        // If less than 500 locations, calculate the centroid and smoothly pan the map
        if (locations.length > 0 && locations.length < 500) {
          const centroid = findGeographicCentroid(locations);
          if (centroid) {
            mapInstance.current.panTo({ lat: centroid[0], lng: centroid[1] }); // Smoothly move to the centroid
          }
        }
  
        // Load `marker` library and add markers
        const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
        locations.forEach((location) => {
          const marker = new AdvancedMarkerElement({
            map: mapInstance.current,
            content: buildContent(location),
            position: {
              lat: location.position?.Latitude || 0,
              lng: location.position?.Longitude || 0,
            },
            title: location.Address,
          });
  
          marker.addListener("click", () => {
            toggleHighlight(marker, location);
          });
  
          markersRef.current.push(marker);
        });
      }
    };
  
    initMapAndMarkers().catch((error) => {
      console.error("Error initializing map and markers:", error);
    });
  }, [mapLoaded, locations]);
  

  const toggleHighlight = (markerView, property) => {
    if (markerView.content.classList.contains('highlight')) {
      markerView.content.classList.remove('highlight');
      markerView.zIndex = null;
    } else {
      markerView.content.classList.add('highlight');
      markerView.zIndex = 1;
    }
  };

  const buildContent = (property) => {
    const content = document.createElement('div');
    content.classList.add('property');

    let imgSrc;
    switch (property.Type) {
      case 'flat':
        imgSrc = require('../Assets/apartments.png');
        break;
      case 'semi-detached':
        imgSrc = require('../Assets/townhouse.png');
        break;
      case 'terrace':
        imgSrc = require('../Assets/terrace.png');
        break;
      case 'house':
        imgSrc = require('../Assets/house1.png');
        break;
      default:
        imgSrc = 'path/to/default-image.png';
    }

    content.innerHTML = `
      <div class="icon">
        <img src="${imgSrc}" alt="${property.Type}" title="${property.Type}" style="width: 32px; height: 32px;">
      </div>
      <div class="img">
      <img src="${property.ImageLink}" alt="${property.Type}" title="${property.Type}">
      </div>
      <div class="details">
        <div class="price">£${property.PriceValue?.toLocaleString(undefined, { maximumFractionDigits: 2 }) || property.Status.Type + "-" + property.Status.datetime}</div>
        <div class="address">${property.Address}</div>
        <div class="features">
          <div>
            <i aria-hidden="true" class="fa fa-bed fa-lg bed" title="bedroom"></i>
            <span class="fa-sr-only">bedroom</span>
            <span>${property.Bedrooms}</span>
          </div>
          <div>
            <i aria-hidden="true" class="fa fa-bath fa-lg bath" title="bathroom"></i>
            <span class="fa-sr-only">bathroom</span>
            <span>${property.Bathrooms}</span>
          </div>
          <div>
            <i aria-hidden="true" class="fa fa-ruler fa-lg size" title="size"></i>
            <span class="fa-sr-only">size</span>
            <span>${property.Space} m<sup>2</sup></span>
          </div>
          <div>
            <a href=${property.URL} target="_blank" rel="noopener noreferrer">View</a>
          </div>
        </div>
      </div>
    `;
    return content;
  };

  return <div ref={mapRef} style={{ height: '500px', width: '100%' }}></div>;
};

export default GoogleMapProperties;
